import * as angular from 'angular';

"use strict";

angular.module('SoundModule', [])

export default 'SoundModule';
